import { render, staticRenderFns } from "./EditContractTerminationForm.vue?vue&type=template&id=b605ec96&"
import script from "./EditContractTerminationForm.vue?vue&type=script&lang=js&"
export * from "./EditContractTerminationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports